import React from 'react';
import { Header, Profiles } from '../components';
import * as ROUTES from '../constants/routes';
import logo from '../logo.svg';

export function SelectProfileContainer({ setProfile }) {
  // useEffect(() => {
  //   localStorage.setItem(
  //     'mum',
  //     JSON.stringify({
  //       displayName: 'Mum',
  //       photoURL: 'https://i.ibb.co/BgQrc43/mum.png',
  //     })
  //   );
  // }, []);

  // const mum = localStorage.getItem('mum');

  // console.log(JSON.parse(mum));

  return (
    <>
      <Header bg={false}>
        <Header.Frame>
          <Header.Logo to={ROUTES.HOME} src={logo} alt="Netflix" />
        </Header.Frame>
      </Header>

      <Profiles>
        <Profiles.Title>Who's watching? </Profiles.Title>
        <Profiles.List>
          <Profiles.User
            onClick={() =>
              setProfile({
                displayName: 'Mansour',
                photoURL: 'https://i.ibb.co/tX8MjGF/mansdev.png',
              })
            }
            data-testid="user-profile"
          >
            <Profiles.Picture src="mansdev" alt="mans" />
            <Profiles.Name>Mansour</Profiles.Name>
          </Profiles.User>
          <Profiles.User
            onClick={() =>
              setProfile({
                displayName: 'Recruiters',
                photoURL:
                  'https://i.ibb.co/TgcpZjw/pexels-rfstudio-3810792.jpg',
              })
            }
            data-testid="user-profile"
          >
            <Profiles.Picture src="rr" alt="recruiters" />
            <Profiles.Name>Recruiters</Profiles.Name>
          </Profiles.User>
        </Profiles.List>
      </Profiles>
    </>
  );
}
